import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Store } from "@ngrx/store";
import { environment } from "../../../environments/environment";
import { HelperService } from '../helper/helper.service';
import {
  fetchChannel,
  getChannel,
  updateChannel,
  deleteChannel,
  addChannel
} from "../../store/channel/channel.actions";
import { Observable } from 'rxjs';
import { IState } from '@models/index';
import { getChannelSelector, getChannelsSelector } from '@store/channel/channel.selectors';

@Injectable({
  providedIn: 'root'
})
export class ChannelService {
  backendUrl = environment.backendUrl;

  constructor(
    private http: HttpClient,
    private store: Store<{ channel: IState }>
  ) {}

  getChannelsSelector(): Observable<IState> {
    return this.store.select(getChannelsSelector);
  }

  getChannelSelector(): Observable<any> {
    return this.store.select(getChannelSelector)
  }

  fetchChannels(page, filterOptions): void {
    this.store.dispatch(fetchChannel({ page, filterOptions }));
  }

  fetchChannel(id): void {
    this.store.dispatch(getChannel({ id }))
  }

  addChannel(channel, filterOptions?) {
    this.store.dispatch(addChannel({ channel, filterOptions }));
  }

  updateChannel(channel, filterOptions?) {
    this.store.dispatch(updateChannel({ channel, filterOptions }));
  }

  deleteChannel(id, filterOptions?) {
    this.store.dispatch(deleteChannel({ id, filterOptions }));
  }


  getChannels(page: number, filterOptions: any = { }) {
    const queryparams = { ...{ page }, ...filterOptions };
    const queryString = HelperService.generateQueryParams(queryparams);
    
    return this.http.get(`${this.backendUrl}/channels?${queryString}`);
  }

  getChannel(id: string) {
    return this.http.get(`${this.backendUrl}/channels/channel/${id}`);
  }

  insertChannel(channel) {
    return this.http.post(`${this.backendUrl}/channels`, channel);
  }

  renewChannel(channel) {
    return this.http.patch(`${this.backendUrl}/channels/channel/${channel.id}`, channel)
  }

  removeChannel(id) {
    return this.http.delete(`${this.backendUrl}/channels/channel/${id}`);
  }


}
